module.exports = __webpack_public_path__ + "static/img/7areaA_12.d05ef99.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/7areaA_12.png
// module id = 1056
// module chunks = 1